import React from "react";
import Fallback from "../../components/Fallback";

const Flow = React.lazy(() => import("./Flow"));
export const FlowScreen: React.FC<any> = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Flow {...props} />
  </React.Suspense>
);
